import React from 'react';
import { TMealPlanItem } from 'interfaces/mealPlan';

import { StyledModal } from './styles';

interface NutritionModalProps {
  open: boolean;
  mealPlanContent: string;
  mealPlanItems: TMealPlanItem[];
  mealPlanName: string;
  nutritionInfo: {
    totalCalories: number;
    totalCarbohydrate: number;
    totalFat: number;
    totalNatrium: number;
    totalProtein: number;
    totalSugar: number;
  };
  onCancel: () => void;
}

const NutritionModal = ({ open, mealPlanName, mealPlanContent, mealPlanItems, nutritionInfo, onCancel }: NutritionModalProps) => {
  return (
    <StyledModal
      className="nutrition-modal"
      title="식단표 구성"
      open={open}
      cancelText="닫기"
      okButtonProps={{ style: { display: 'none' } }}
      onCancel={onCancel}
    >
      <div className="meal-plan-name">{mealPlanName}</div>
      <div className="font-bold">원산지 구성</div>
      <div className="meal-plan-content font-xs basic-sd-gray">{mealPlanContent}</div>
      <div className="font-bold">영양 정보</div>
      <div className="nutrition font-xs basic-sd-gray">
        <div>
          <span>총 칼로리</span>
          <span>{nutritionInfo.totalCalories} kcal</span>
        </div>
        <div>
          <span>총 나트륨</span>
          <span>{nutritionInfo.totalNatrium} mg</span>
        </div>
        <div>
          <span>총 탄수화물</span>
          <span>{nutritionInfo.totalCarbohydrate} g</span>
        </div>
        <div>
          <span>총 단백질</span>
          <span>{nutritionInfo.totalProtein} g</span>
        </div>
        <div>
          <span>총 지방</span>
          <span>{nutritionInfo.totalFat} g</span>
        </div>
        <div>
          <span>총 당류</span>
          <span>{nutritionInfo.totalSugar} g</span>
        </div>
      </div>
      <div className="font-bold">식단 구성</div>
      <div>
        {mealPlanItems.map((menu) => {
          return (
            <div key={menu.mealPlanItemIdx} className="meal-plan-item font-xs">
              <div className="meal-plan-item-name">
                <span>{menu.mealPlanItemName}</span>
                <span>{menu.calories || 0} kcal</span>
              </div>
              <div className="item-nutrition basic-sd-gray">
                <span>나트륨 : {menu.natrium || 0} | </span>
                <span>탄수화물 : {menu.carbohydrate || 0} | </span>
                <span>단백질 : {menu.protein || 0} | </span>
                <span>지방 : {menu.fat || 0} | </span>
                <span>당류 : {menu.sugar || 0}</span>
              </div>
              <div className="item-nutrition basic-sd-gray">함유된 알레르기 유발 물질 : {menu.description || '-'}</div>
            </div>
          );
        })}
      </div>
    </StyledModal>
  );
};

export default NutritionModal;
